import React from 'react';
import {Radio,  Button, Checkbox, Dropdown, Divider, Icon, Breadcrumb,  Label,  Form, Header, Input, Message, Image, TextArea, Popup, Segment} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import {genericFormattedForDropdownByNombre, genericFormattedForDropdown, genericFormattedForDropdownTexto} from '../../selectors/selectors';
//import { DateRangePicker, SingleDatePicker, DayPickerRangeController, isInclusivelyAfterDay } from 'react-dates';
import moment from 'moment';
//import 'react-dates/initialize';
//import 'react-dates/lib/css/_datepicker.css';
import 'moment/locale/es';
//import TimeField from 'react-simple-timefield';
//import TimeInput from 'react-time-input';
moment.locale('es');   

const FormMaker=({ onChange, datosGenerales, onSave, errors, formulario, onAgregarImagenServicio, show, inicio, onDateChangeInicio,focusedInicio, onFocusChangeInicio, onBorrarArchivo, admin=1 })=>{

    inicio:new moment().add(15, 'd')
    
    function mostrar(datosGenerales, dato1,dato2){
        
        let condicion = false;
        if(dato1){
            let field=dato1.split(',');
            if(field.length==1){    
                if(datosGenerales[field[0]] == dato2){
                    condicion= true;
                }
            }else{
                for(let i=0; i<=field.length; i++){
                    if(datosGenerales[field[i]] == dato2){
                        condicion= true; 
                    }
                }
            }
    
        }else{
            condicion = true;
        }
        
        return condicion;
    }
    
    
    function nombre(cadena){    
        var res = cadena.split("/");
        return res[5];
    }
    
    function mostrarAviso(datosGenerales, pregunta){
        
        let condicion = true;
        
       
        for(let i=0; i<pregunta.respuestaList.length; i++){
           
            if(eval(datosGenerales[pregunta.id+pregunta.respuestaList[i].value])==1){
                condicion=false;
            }
            
        }      
      
        return condicion;
    }
   
   
    
	return (
        
          <Form>    
             {formulario.map(form =>
             
              <div>
                            
                <Header as='h3' dividing>
                    <Header.Content>
                        {form.titulo}
                        <Header.Subheader>
                            {form.nota}
                        </Header.Subheader>
                    </Header.Content>
                </Header>

                    {form.pregunta.map(pregunta=>
                     <div>
                        {pregunta.validarSeMuestra==false || mostrar(datosGenerales, pregunta.campoSeMuestra,pregunta.condicionSeMuestra )?
                            <div>   
                            <Divider hidden />

    
                            {pregunta.aviso?
                                  <Message style={{background: '#e1caa2'}}>
                                    <Message.Header>AVISO</Message.Header>
                                    <p>
                                        {pregunta.aviso}
                                    </p>
                                  </Message>  
                                :""}   
    
    
                            
                            {pregunta.tipo=="input"?
                               <div>
                                    {pregunta.nota?
                                      <Message style={{background: '#e1caa2'}}>
                                        <Message.Header>AVISO</Message.Header>
                                        <p>
                                            {pregunta.nota}
                                        </p>
                                      </Message>  
                                    :""}
                                
                                    <p>
                                   
                                    <Form.Field error={errors[pregunta.id]}>
                                            <label>{pregunta.nombre}</label>
                                            <Input
                                                placeholder={pregunta.placeholder}
                                                name={pregunta.id}                    
                                                value={datosGenerales[pregunta.id]}
                                                onChange={onChange}
                                              />
                                        </Form.Field>
                                    </p>
                                </div>

                            :
                                ""
                            }
                            
                            
                            

                            
                            
                            
                            {pregunta.tipo=="modal"?
                               <div>
                                    <Form.Field >
                                       <Button onClick={show}>{pregunta.nota}</Button>
                                    </Form.Field>
                            
                                </div>

                            :
                                ""
                            }



                            {pregunta.tipo=="adjunto"?
                               <div>
                                    <Form.Field error={errors[pregunta.id]}>
                                        <label>{pregunta.nombre}</label>
                                       <Input
                                            type='file'
                                            placeholder={pregunta.placeholder}
                                            name={pregunta.id+"_"+pregunta.id}                    
                                            value={datosGenerales[pregunta.id+"_"+pregunta.id]}
                                            onChange={onChange}
                                          />
                                    </Form.Field>
                                    
                                    <Button color='gray'
                                    onClick={(event)=>onAgregarImagenServicio(event, "servicio")} 
                                    >Agregar</Button>
                            
                                    
                                
                                    
                                    {datosGenerales[pregunta.id]!=null?
                                    
                                            <Message style={{background: '#e1caa2'}}>
                                            {datosGenerales[pregunta.id].map(archivo=>
                                                <p>
                                                    <a href={archivo} target="_blank">Archivo:{nombre(archivo)}</a>
                                                    <Popup
                                                        trigger={
                                                            <Icon name='x' link  size='large' 
                                                                color='orange'  
                                                                onClick={()=>onBorrarArchivo(pregunta.id, archivo)} 
                                                            />
                                                        }
                                                        content='Borrar archivo.'
                                                      />                                                            
                                                </p>
                                            )}
                                            </Message> 
                                            
                                    :
                                        ""
                                    }
                                    
                            
                            
                                    {datosGenerales[pregunta.id]==null && pregunta.nota?
                                      <Message style={{background: '#e1caa2'}}>
                                        <Message.Header>AVISO</Message.Header>
                                        <p>
                                            {pregunta.nota}
                                        </p>
                                      </Message>  
                                    :""}
                            
                            
                                </div>

                            :
                                ""
                            }

                            {pregunta.tipo=="checkbox"?
                               <div>
                                
                                
                                {pregunta.nota && mostrarAviso(datosGenerales, pregunta)?
                                  <Message style={{background: '#e1caa2'}}>
                                    <Message.Header>AVISO</Message.Header>
                                    <p>
                                        {pregunta.nota}
                                    </p>
                                  </Message>  
                                :""}    
                                
                                <Form.Field error={errors[pregunta.id]}>
                                    <label>{pregunta.nombre}</label>    
                                    {pregunta.respuestaList.map(opcion=>
                                        <div>
                                            {admin==0?
                                                <div>
                                                {opcion.correcto=="1"?
                                                <Checkbox 
                                                    label={opcion.texto1 +' (opción correcta)'}
                                                    name={pregunta.id+'_'+opcion.id}
                                                    style={{'background-color': 'green', 'padding': '7px 20px'}}
                                                    value={opcion.value}
                                                    checked={eval(datosGenerales[pregunta.id+'_'+opcion.id])==1?true:false}
                                                    onChange={onChange}
                                                  />
                                                  :
                                                  <Checkbox 
                                                    label={opcion.texto1}
                                                    name={pregunta.id+'_'+opcion.id}
                                                    value={opcion.value}
                                                    checked={eval(datosGenerales[pregunta.id+'_'+opcion.id])==1?true:false}
                                                    onChange={onChange}
                                                  />
                                                 } 
                                                 </div>
                                             
                                              :
                                                <Checkbox 
                                                    label={opcion.texto1}
                                                    name={pregunta.id+'_'+opcion.id}
                                                    value={opcion.value}
                                                    checked={eval(datosGenerales[pregunta.id+'_'+opcion.id])==1?true:false}
                                                    onChange={onChange}
                                                  />
                                              
                                              }
                                          
                                              
                                              
                                              <br/>
                                        </div>      

                                    )}
                                    </Form.Field>
                                    
                                    
                                    
                                    
                                    
                                </div>

                            :
                                ""
                            }
                            
                            {pregunta.tipo=="radio"?
                               <div>
                                <Form.Field error={errors[pregunta.id]}>
                                <label>{pregunta.nombre}</label>
                                {pregunta.respuestaList.map(opcion=>

                                    
                                    <div>
                                
                                        {admin==0?
                                                <div>
                                                {opcion.correcto=="1"?
                                
                                                   <Radio
                                                        label={opcion.texto1 +' (opción correcta)'}
                                                        style={{'background-color': 'green', 'padding': '7px 20px'}}
                                                        name={pregunta.id}                    
                                                        value={opcion.value}
                                                        checked={Number(eval(datosGenerales[pregunta.id])) == Number(opcion.value)}
                                                        onChange={onChange}
                                                      />
                                                    :
                            
                                                    <Radio
                                                        label={opcion.texto1}
                                                        name={pregunta.id}                    
                                                        value={opcion.value}
                                                        checked={Number(eval(datosGenerales[pregunta.id])) == Number(opcion.value)}
                                                        onChange={onChange}
                                                      />
                                                }
                                                </div>
                                        :
                                        
                                             <Radio
                                                    label={opcion.texto1}
                                                    name={pregunta.id}                    
                                                    value={opcion.value}
                                                    checked={Number(eval(datosGenerales[pregunta.id])) == Number(opcion.value)}
                                                    onChange={onChange}
                                                  />
                                
                                        }
                                        <br/>
                                    </div>          
                                    

                                )}
                                </Form.Field>
                                {eval(datosGenerales[pregunta.id])==0 && pregunta.nota?
                                  <Message style={{background: '#e1caa2'}}>
                                    <Message.Header>AVISO</Message.Header>
                                    <p>
                                        {pregunta.nota}
                                    </p>
                                  </Message>  
                                :""}    
                                
                                
                                </div>

                            :
                                ""
                            }

                            

                            {pregunta.tipo=="dropdown"?
                               <div>
                                    <Form.Field error={errors[pregunta.id]}>
                                    <label>{pregunta.nombre}</label>    
                                       <Dropdown 
                                            placeholder={pregunta.placeholder}
                                            fluid
                                            name={pregunta.id}
                                            onChange={onChange}
                                            value={datosGenerales[pregunta.id]}
                                            search
                                            selection
                                            options={genericFormattedForDropdownTexto(pregunta.respuestaList)}
                                          />
                                    </Form.Field>
                                </div>

                            :
                                ""
                            }

                            {pregunta.tipo=="textArea"?
                               <div>
                                    <Form.Field error={errors[pregunta.id]}>  
                                    <label>{pregunta.nombre}</label>
                                        <TextArea placeholder={pregunta.placeholder} name={pregunta.id} onChange={onChange}
                                            value={datosGenerales[pregunta.id]==null?"":datosGenerales[pregunta.id]}
                                            style={{ minHeight: 160 }} 
                                           
                                           />    
                                          Caracteres (hasta 1000):{datosGenerales[pregunta.id]==null?"":(datosGenerales[pregunta.id]).length}
                                    </Form.Field>
                                </div>

                            :
                                ""
                            }



                            </div>
                        :
                        ""
                        }
                        
                        </div>
                                       
                    )}
    
              
              
              </div>
             
             )}
        </Form>

	);
};



export default FormMaker;